export const SET_DELETE_PASSENGER_FROM_SINGLE_FLIGHT =
  'SET_DELETE_PASSENGER_FROM_SINGLE_FLIGHT'

export default () => ({
  type: SET_DELETE_PASSENGER_FROM_SINGLE_FLIGHT,
})
